<template>
    <div class="edc-service-detail">
        <div class="edc-service-detail__overlay" @click="onClose"></div>
        <div class="edc-service-detail__content">
            <button class="edc-service-detail__close" @click="onClose">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="48" rx="24" fill="white"/>
                    <path d="M24 26.24L16.16 34.08C15.8667 34.3733 15.4934 34.52 15.04 34.52C14.5867 34.52 14.2134 34.3733 13.92 34.08C13.6267 33.7866 13.48 33.4133 13.48 32.96C13.48 32.5066 13.6267 32.1333 13.92 31.84L21.76 24L13.92 16.16C13.6267 15.8666 13.48 15.4933 13.48 15.04C13.48 14.5866 13.6267 14.2133 13.92 13.92C14.2134 13.6266 14.5867 13.48 15.04 13.48C15.4934 13.48 15.8667 13.6266 16.16 13.92L24 21.76L31.84 13.92C32.1334 13.6266 32.5067 13.48 32.96 13.48C33.4134 13.48 33.7867 13.6266 34.08 13.92C34.3734 14.2133 34.52 14.5866 34.52 15.04C34.52 15.4933 34.3734 15.8666 34.08 16.16L26.24 24L34.08 31.84C34.3734 32.1333 34.52 32.5066 34.52 32.96C34.52 33.4133 34.3734 33.7866 34.08 34.08C33.7867 34.3733 33.4134 34.52 32.96 34.52C32.5067 34.52 32.1334 34.3733 31.84 34.08L24 26.24Z" fill="#EB5E5E"/>
                </svg>
            </button>
            <img class="edc-service-detail__photo" :src="data?.image" :alt="normalizeText(data?.name || data?.title || '')" />
            <!-- Food -->
            <div class="edc-service-detail__inner" v-if="type === 1">
                <p v-if="data?.service_type" class="edc-service-detail__kind">{{ serviceTypeLabel(data.service_type) }}</p>
                <h2 class="edc-service-detail__title">{{ normalizeText(data?.name || data?.title || 'Sin nombre') }}</h2>
                <p class="edc-service-detail__value" v-if="data?.type">Tipo: {{ normalizeText(data?.type) }}</p>
                <div v-if="data?.description">
                    <p class="edc-service-detail__label">Descripción:</p>
                    <p class="edc-service-detail__description" v-html="descriptionAsHtml(data?.description)"></p>
                </div>
            </div>
            <!-- Transport -->
            <div class="edc-service-detail__inner" v-if="type === 2">
                <p v-if="data?.service_type" class="edc-service-detail__kind">{{ serviceTypeLabel(data.service_type) }}</p>
                <h2 class="edc-service-detail__title">{{ normalizeText(data?.name) }}</h2>
                <div class="edc-service-detail__fields" v-if="data?.type || data?.departure || data?.destination">
                    <p class="edc-service-detail__value edc-service-detail__field">Vehículo: {{ normalizeText(data?.type) }}</p>
                    <p class="edc-service-detail__value edc-service-detail__field">Salida: {{ normalizeText(data?.departure) }}</p>
                    <p class="edc-service-detail__value edc-service-detail__field">Destino: {{ normalizeText(data?.destination) }}</p>
                </div>
                <p class="edc-service-detail__label">Descripción:</p>
                <p class="edc-service-detail__description" v-html="descriptionAsHtml(data?.description)"></p>
                <p class="edc-service-detail__label">Recomendaciones:</p>
                <p class="edc-service-detail__description" v-html="descriptionAsHtml(data?.recommendation)"></p>
            </div>
            <!-- Hotel -->
            <div class="edc-service-detail__inner" v-if="type === 3">
                <p v-if="data?.service_type" class="edc-service-detail__kind">{{ serviceTypeLabel(data.service_type) }}</p>
                <h2 class="edc-service-detail__title">{{ normalizeText(data?.type) }}</h2>
                <p class="edc-service-detail__value">Capacidad: {{ normalizeText(data?.capacity) }} persona(s)</p>
                <div class="edc-service-detail__amenities">
                    <p class="edc-service-detail__value edc-service-detail__amenity" :class="[data?.ac ? 'active' : '']">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
                            <path d="M10.6 13.8L8.45 11.65C8.26667 11.4667 8.03333 11.375 7.75 11.375C7.46667 11.375 7.23333 11.4667 7.05 11.65C6.86667 11.8333 6.775 12.0667 6.775 12.35C6.775 12.6333 6.86667 12.8667 7.05 13.05L9.9 15.9C10.1 16.1 10.3333 16.2 10.6 16.2C10.8667 16.2 11.1 16.1 11.3 15.9L16.95 10.25C17.1333 10.0667 17.225 9.83333 17.225 9.55C17.225 9.26667 17.1333 9.03333 16.95 8.85C16.7667 8.66667 16.5333 8.575 16.25 8.575C15.9667 8.575 15.7333 8.66667 15.55 8.85L10.6 13.8ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22Z" />
                        </svg>
                        Aire acondicionado
                    </p>
                    <p class="edc-service-detail__value edc-service-detail__amenity" :class="[data?.private_bathroom ? 'active' : '']">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
                            <path d="M10.6 13.8L8.45 11.65C8.26667 11.4667 8.03333 11.375 7.75 11.375C7.46667 11.375 7.23333 11.4667 7.05 11.65C6.86667 11.8333 6.775 12.0667 6.775 12.35C6.775 12.6333 6.86667 12.8667 7.05 13.05L9.9 15.9C10.1 16.1 10.3333 16.2 10.6 16.2C10.8667 16.2 11.1 16.1 11.3 15.9L16.95 10.25C17.1333 10.0667 17.225 9.83333 17.225 9.55C17.225 9.26667 17.1333 9.03333 16.95 8.85C16.7667 8.66667 16.5333 8.575 16.25 8.575C15.9667 8.575 15.7333 8.66667 15.55 8.85L10.6 13.8ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22Z" />
                        </svg>
                        Baño privado
                    </p>
                </div>
                <p class="edc-service-detail__label">Descripción:</p>
                <p class="edc-service-detail__description" v-html="descriptionAsHtml(data?.description)"></p>
            </div>
            <!-- Tour -->
            <div class="edc-service-detail__inner" v-if="type === 4">
                <p v-if="data?.service_type" class="edc-service-detail__kind">{{ serviceTypeLabel(data.service_type) }}</p>
                <h2 class="edc-service-detail__title">{{ normalizeText(data?.name) }}</h2>
                <template v-if="normalizeText(data?.description)">
                    <p class="edc-service-detail__label">Detalle del servicio</p>
                    <p class="edc-service-detail__description">{{ normalizeText(data?.description) }}</p>
                </template>
                <template v-if="normalizeText(data?.more_information)">
                    <p class="edc-service-detail__label">Contacto y reservas</p>
                    <p class="edc-service-detail__description edc-service-detail__description--contact">{{ normalizeText(data?.more_information) }}</p>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { linkifyPlainText } from '@/utils/linkifyPlainText';

export default {
    name: "edc-service-detail",
    props: {
        type: {
            type: Number,
            validator(value) {
                return [1, 2, 3, 4].includes(value)
            }
        },
        data: {
            type: Object
        }
    },
    methods: {
        onClose() {
            this.$emit('close')
        },
        /**
         * Normaliza texto que viene de BD / inputs:
         * - quita "Hangul Filler" (ㅤ) y NBSP
         * - colapsa espacios/tabs repetidos
         * - conserva saltos de línea
         */
        descriptionAsHtml(value) {
            return linkifyPlainText(this.normalizeText(value));
        },
        normalizeText(value) {
            if (value === null || value === undefined) return ''
            let text = String(value)
            // U+3164 "Hangul Filler" (se usa como relleno visual en algunos editores).
            // No lo eliminamos: lo convertimos en un espacio para evitar que textos queden pegados.
            text = text.replace(/\u3164+/g, ' ')
            // Invisibles comunes que a veces vienen de copypaste
            text = text.replace(/\u200B/g, '') // zero-width space
            text = text.replace(/\uFEFF/g, '') // BOM / zero-width no-break
            // NBSP
            text = text.replace(/\u00A0/g, ' ')
            // Separadores "°" repetidos que a veces vienen de plantillas/CMS
            text = text.replace(/°+/g, '\n')
            // Normalizar saltos de línea
            text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
            // Quitar espacios alrededor de saltos de línea
            text = text.replace(/ *\n */g, '\n')
            // Colapsar varias líneas vacías
            text = text.replace(/\n{3,}/g, '\n\n')
            // Colapsar espacios/tabs repetidos en una sola celda
            text = text.replace(/[ \t]+/g, ' ')
            return text.trim()
        },
        serviceTypeLabel(code) {
            const labels = {
                PLA: 'Gastronomía',
                TRA: 'Transporte',
                HOS: 'Hospedaje',
                TOU: 'Tour',
            }
            return labels[code] || code || ''
        },
    }
}
</script>

<style>
.edc-service-detail {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 9999;
}

.edc-service-detail__overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .75);
}

.edc-service-detail__content {
    width: 100%;
    max-width: 450px;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: white;
    border-radius: 16px 16px 0px 0px;
    overflow: hidden;
    border: 1px solid rgba(80, 59, 47, 0.15);
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.10);
    /* Evita que la card se salga de pantalla con descripciones largas. */
    max-height: 90vh;
    overflow-y: auto;
}

.edc-service-detail__close {
    position: absolute;
    right: 16px;
    top: 16px;
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
}

.edc-service-detail__photo {
    width: 100%;
    height: 200px;
    object-fit: cover;
}

.edc-service-detail__inner {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: #FFFEEC;
}

.edc-service-detail__kind {
    display: inline-block;
    align-self: flex-start;
    margin: 0 0 6px;
    padding: 4px 10px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--color-primary, #a153aa);
    background: rgba(161, 83, 170, 0.12);
    border-radius: 999px;
}

.edc-service-detail__title {
    font-size: 1.35rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 0;
}

.edc-service-detail__label {
    font-weight: bold;
    color: var(--color-dark);
    font-size: 0.95rem;
}

.edc-service-detail__value {
    display: flex;
    align-items: center;
    gap: 6px;
    fill: var(--color-dark);
    color: var(--color-dark);
}

.edc-service-detail__description {
    display: block;
    align-items: unset;
    margin-top: 0;
    line-height: 1.5;
    /* Respetar saltos de línea pero colapsar espacios repetidos */
    white-space: pre-line;
    text-align: justify;
    color: var(--color-dark);
}

.edc-service-detail__description--contact {
    text-align: left;
    font-size: 0.9rem;
    line-height: 1.55;
}

.edc-service-detail__value.active {
    fill: var(--color-primary);
    color: var(--color-primary);
} 

.edc-service-detail__value.active svg {
    fill: var(--color-primary);
    opacity: 1;
} 

.edc-service-detail__value svg {
    opacity: 0.5;
}

.edc-service-detail__fields {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
}

.edc-service-detail__amenities {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 16px;
}

.edc-service-detail__field,
.edc-service-detail__amenity {
    background-color: rgba(161, 83, 170, 0.08);
    border: 1px solid rgba(80, 59, 47, 0.12);
    border-radius: 12px;
    padding: 10px 12px;
}

.edc-service-detail__amenity {
    border-radius: 999px;
}

/* Reset default margins so el modal queda controlado por el layout */
.edc-service-detail__inner h2,
.edc-service-detail__inner p {
    margin: 0;
}

@media (min-width: 920px) {
    .edc-service-detail { align-items: center }
    .edc-service-detail__content { border-radius: 16px }
    .edc-service-detail__fields { grid-template-columns: 1fr 1fr; }
}
</style>